<template>
  <Content id="users">
    <div slot="search">
      <Form :label-width="50" :model="search" id="searchForm">
        <Row>
          <Col><FormItem label="用户名" :label-width="60"><Input v-model="search.name"/></FormItem></Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="query">查询</Button></div></Col>
        </Row>
      </Form>
    </div>

    <el-table :data="userList" style="width: 100%;" tooltip-effect="dark" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">
      <el-table-column align="center" prop="id" label="用户id" min-width="80"/>
      <el-table-column align="center" prop="name" label="用户名" min-width="80"/>
      <el-table-column align="center" prop="realName" label="真实姓名" min-width="80"/>
      <el-table-column align="center" prop="remark" label="备注" min-width="80"/>
      <el-table-column align="center" prop="operator" label="操作员" min-width="80"/>
      <el-table-column align="center" prop="createTime" label="创建时间" min-width="100"/>
      <el-table-column align="center" prop="status" label="状态"  min-width="80">
        <template slot-scope="{row}">
          <el-tag size="small" :type="row.status===2?'danger':'primary'" disable-transitions>{{row.status==1?'启用':'禁用'}}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <Page :total="userPageList.total" :current="userPageList.currentPage" :page-size="userPageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]" @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

  </Content>
</template>
<script>
import {
  _roleUserByPages // 列表
} from "@/services/manage/users";
export default {
  name: "Users",
  data() {
    return {
      search: {
        name: "",
        roleId: ""
      },
      tableHeight: 0,
      currentRowIndex: null,
      userWindow: false,
      title: "用户列表",
      roleId: "",
      userList: [],
      userPageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      searchElem: [
        {
          label: '用户名',
          labelWidth: 80,
          prop: "name",
          placeholder: "",
          icon: "md-search"
        },
      ],
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    openWindow(row){
      this.search.name = "";
      this.search.roleId = row.id;
      this.userWindow = true;
      this.roleId = row.id;
      this.handleDataList();
    },
    query(){
      this.userPageList.currentPage = 1;
      this.handleDataList();
    },
    handleDataList() {
      _roleUserByPages({
        ...this.search,
        ...this.userPageList,
      }).then(res => {
        this.userList = res.data.records;
        this.userPageList.total = res.data.total;
      }).catch(() => {});
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentRowIndex = e.index;
    },
    chagecurrent(e){
      this.userPageList.currentPage=e
      this.handleDataList();
    },
    chagepagesize(e){
      this.userPageList.pageSize=e
      this.handleDataList();
    },
  }
};
</script>
<style lang="postcss" scoped>
/deep/.ivu-card-body{padding: 16px;padding-top: 0px;}
/deep/ .ivu-form-item{margin-bottom: 0px;}

</style>
